import { render, staticRenderFns } from "./CountersCheck.vue?vue&type=template&id=4c10866c&scoped=true"
import script from "./CountersCheck.vue?vue&type=script&lang=js"
export * from "./CountersCheck.vue?vue&type=script&lang=js"
import style0 from "./CountersCheck.vue?vue&type=style&index=0&id=4c10866c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10866c",
  null
  
)

export default component.exports